export default "__VITE_ASSET__QOXcNyJH__"